module.exports = "/assets/data/970026482a253a82a622a2c134ab8221-B79.data.json";